var map = {
	"./de/general11/slide3.svg": 451197,
	"./en/general11/slide3.svg": 20257,
	"./es/general11/slide3.svg": 509034,
	"./fr/general11/slide3.svg": 563250,
	"./nl/general11/slide3.svg": 778844,
	"./pt/general11/slide3.svg": 46278
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 170473;